import {
  Box,
  FormControl,
  FormControlLabel,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from "./priestScheduleReport.module.scss";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as XLSX from "xlsx";
import { isNil } from "lodash";
// import { CustomSelect, CustomInputLabel, CustomRadioButton, CommonButton, CustomMenuItem } from "components/common/StyledComponents/StyledFields";
// import { apiRequest } from "infrastructure/backendService";
import { apiRequest } from "../../infrastructure/backendService";
import { CustomSelect, CustomInputLabel, CustomRadioButton, CommonButton, CustomMenuItem } from "../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "12px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #F2BE22",
    fontWeight: "700",
    color: theme.palette.common.white,
    // writingMode: "horizontal-rl", // Vertical writing mode
    // textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "center",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",

    // transform: "rotate(180deg)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set odd rows to white
  },
  "&:nth-of-type(even)": {
    backgroundColor: " #FFF9E4", // Set even rows to yellow
  },
}));

const PriestScheduleReport = () => {
  const currentDate = new Date();
  const Months = [
    { id: "JAN", month: "January" },
    { id: "FEB", month: "February" },
    { id: "MAR", month: "March" },
    { id: "APR", month: "April" },
    { id: "MAY", month: "May" },
    { id: "JUN", month: "June" },
    { id: "JUL", month: "July" },
    { id: "AUG", month: "August" },
    { id: "SEP", month: "September" },
    { id: "OCT", month: "October" },
    { id: "NOV", month: "November" },
    { id: "DEC", month: "December" },
  ];

  var currentMonthNumber = currentDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
  const [selectedYear, setSelectedYear] = useState<number>(
    currentDate.getFullYear()
  );
  const [selectedMonthID, setSelectedMonthID] = useState<any>(
    currentMonthNumber
  );
  const [selectedQuater, setSelectedQuater] = useState<string>("");
  const [showMonthly, setShowMonthly] = useState<boolean>(false);
  const [showQuaterly, setShowQuaterly] = useState<boolean>(false);
  const [showYearly, setShowYearly] = useState<boolean>(false);
  const [occuranceType, setOccuranceType] = useState<string>("");
  const [errMessage, setErrMessage] = useState("");
  const [ReportData, setReportData] = useState<any[]>([]);
  const [tableHeaders, setTableHeaders] = useState<any>({});
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [isAPICalled, setIsAPICalled] = useState(false);

  const Years = [
    {
      year: 2023,
    },
    {
      year: 2024,
    },
  ];

  const handlesubmit = () => {
    apiCall();
  };


  const apiCall = () => {
    setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: `/report-dashboard/priestScheduleReports/${occuranceType}`,
      params: {
        selectedMonth: showMonthly ? selectedMonthID : "",
        selectedYear: selectedYear,
        monthRange: showQuaterly ? selectedQuater : "",
      },
      includeToken: true,
    })
      .then((res: any) => {
        setReportData(res?.data?.data);
        setTableHeaders(res?.data?.columns);
        setLoading(false);
        setSearchButton(true);
        setIsAPICalled(true);
      })
      .catch((err: any) => {
        console.log(err);
        setErrMessage(
          isNil(err.response.data.errorMessage)
            ? `${err.message}`
            : `${err.response.data}`
        );
        setLoading(false);
        setIsAPICalled(true);
      });
  };

  const quaterlyYearsList = ["Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"];

  const handlequaterlyChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedQuater(event.target.value as string);
    setSearchButton(false);
  };

  const quaterlyYearsDropdown = () => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handlequaterlyChange}
          value={selectedQuater}
          placeholder="Please Select"
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {quaterlyYearsList.map((item, i) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const handleYearChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedYear(event.target.value as number);
    setSearchButton(false);
  };

  const handleMonthChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedMonthID(event.target.value as number);
    setSearchButton(false);
  };

  const YearsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handleYearChange}
          value={selectedYear}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {Years.map((item, i) => (
            <CustomMenuItem value={item.year} key={i}>
              {item.year}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const MonthsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdown}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handleMonthChange}
          value={selectedMonthID}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {Months.map((item, i) => (
            <CustomMenuItem value={item.id} key={i}>
              {item.month}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const monthlyComponent = () => {
    return (
      <Box className={styles.dropdownConatiner}>
        <Box>
          <CustomInputLabel>Month</CustomInputLabel>
          {MonthsDropdown()}
        </Box>
        <Box>
          <CustomInputLabel>Year</CustomInputLabel>
          {YearsDropdown()}
        </Box>
      </Box>
    );
  };

  const quaterlyComponent = () => {
    return (
      <Box className={styles.dropdownConatiner}>
        <Box>
          <CustomInputLabel>Search By Quarterly</CustomInputLabel>
          {quaterlyYearsDropdown()}
        </Box>
        <Box>
          <CustomInputLabel>Year</CustomInputLabel>
          {YearsDropdown()}
        </Box>
      </Box>
    );
  };

  const yearlyComponent = () => {
    return (
      <Box sx={{ width: "100%" }} className={styles.dropdownConatiner}>
        <Box>
          <CustomInputLabel>Search By Yearly</CustomInputLabel>
          {YearsDropdown()}
        </Box>
      </Box>
    );
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setSearchButton(false);
    // Update state based on the selected radio button
    switch (selectedValue) {
      case "Weekly":
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(false);
        setSelectedMonthID(currentMonthNumber);
        break;
      case "Monthly":
        setShowMonthly(true);
        setShowQuaterly(false);
        setShowYearly(false);
        setSelectedYear(currentDate.getFullYear());
        setSelectedQuater("");
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Monthly");
        break;
      case "Search By Quarterly":
        setShowMonthly(false);
        setShowQuaterly(true);
        setShowYearly(false);
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Quarterly");
        break;
      case "Search By Yearly":
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(true);
        setSelectedQuater("");
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthID(currentMonthNumber);
        setOccuranceType("Yearly");
        break;
      default:
        setShowMonthly(false);
        setShowQuaterly(false);
        setShowYearly(false);
        setSelectedQuater("");
        setSelectedYear(currentDate.getFullYear());
        setSelectedMonthID(currentMonthNumber);
    }
  };

  const radioButtonsComponent = () => {
    return (
      <Box className={styles.radioButtonsContainer}>
        <FormControlLabel
          value="Weekly"
          control={<CustomRadioButton disabled />}
          label="Weekly"
        />
        <FormControlLabel
          value="Monthly"
          control={
            <CustomRadioButton
              checked={showMonthly}
              onChange={handleRadioChange}
            />
          }
          label="Monthly"
        />
        <FormControlLabel
          value="Search By Quarterly"
          control={
            <CustomRadioButton
              checked={showQuaterly}
              onChange={handleRadioChange}
            />
          }
          label="Search By Quarterly"
        />
        <FormControlLabel
          value="Search By Yearly"
          control={
            <CustomRadioButton
              checked={showYearly}
              onChange={handleRadioChange}
            />
          }
          label="Search By Yearly"
        />
      </Box>
    );
  };

  const processedReportInfo = ReportData?.map((item) => {
    return Object.fromEntries(
      Object.entries(item).map(([key, value]) => {
        if (typeof value === "string" && value.includes("\n")) {
          // Replace "\n" with line breaks
          return [key, value.split("\n").join("<br>")];
        }
        return [key, value];
      })
    );
  });

  const handleExportToExcel = () => {
    const processedReportInfoForEx = ReportData?.map((item: any) => {
      return Object.fromEntries(
        Object.entries(item).map(([key, value]) => {
          // Use headerMapping to map the keys
          const mappedKey = tableHeaders[key] || key;

          if (typeof value === "string" && value.includes("\n")) {
            // Replace "\n" with line breaks
            return [mappedKey, value.split("\n").join(" ")];
          }

          return [mappedKey, value];
        })
      );
    });

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the table data to worksheet format
    const worksheet = XLSX.utils.json_to_sheet(processedReportInfoForEx);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "ReportData");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "Priest_Schedule_Report.xlsx");
  };

  const renderData = () => {
    return (
      <>
        <StyledTableContainer sx={{ width: "100%" }}>
            <StyledTable aria-label="customized table">
              <TableHead>
                <TableRow>
                  {Object.values(tableHeaders).map((header: any) => (
                    <StyledTableCell align="center" key={header}>
                      <div dangerouslySetInnerHTML={{ __html: header }} />
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {ReportData.map((item, index) => (
                  <StyledTableRow key={index}>
                    {Object.keys(tableHeaders).map((column) => (
                      <StyledTableCell key={column}>
                        <div dangerouslySetInnerHTML={{ __html: item[column] }} />
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>
            </StyledTable>
        </StyledTableContainer>
      </>
    );
  };

  const renderComponent = () => {
    return (
      <>
        {showMonthly ? monthlyComponent() : ""}
        {showQuaterly ? quaterlyComponent() : ""}
        {showYearly ? yearlyComponent() : ""}
      </>
    );
  };

  const reportComponent = () => {
    return (
      <>
        {ReportData.length > 0 ? (
          renderData()
        ) : (
          isAPICalled && <Typography component={"h3"}>No Data</Typography>
        )}
      </>
    );
  };

  const handleSubmitPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      handlesubmit();
    }
  };

  return (
    <div>
      {radioButtonsComponent()}
      {renderComponent()}
      <Box sx={{ display: "flex", alignItems: "center", my: "20px" }}>
        <CommonButton
          className={styles.search}
          onClick={handlesubmit}
          onKeyDown={handleSubmitPress}
          disabled={searchButton || loading}
          id="search"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Loading...
              </span>
            </>
          ) : (
            "Search"
          )}
        </CommonButton>
        {processedReportInfo.length !== 0 && (
          <CommonButton onClick={handleExportToExcel} sx={{ ml: "20px" }}>
            Export to Excel
          </CommonButton>
        )}
      </Box>
      {reportComponent()}
    </div>
  );
};

export default PriestScheduleReport;
